<template>
  <div v-if="user">

    <!-- Content -->
    <div ref="card" class="card">
      <div :style="{ 'background-color': currentEvaluation.color }"
           class="card-header">
        <div>
          <!-- Current snapshot title -->
          <button id="title" class="btn btn-outline-light dropdown-toggle" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
            <b>{{ recipientFullName }}</b>
          </button>
          <div class="dropdown-menu snapshot-infos">
            <table class="table-borderless">
              <tbody>
                <tr>
                  <th scope="row">{{ $t('recipient') }}</th>
                  <td>{{ recipientFullName }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('evaluation.snapshot.author') }}</th>
                  <td>{{ snapshotCreator }}</td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('creation') }}</th>
                  <td>{{ currentEvaluation.snapshot ? formatDate(currentEvaluation.snapshot.created_at) :
                  '' }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('evaluation.snapshot.last_updated') }}</th>
                  <td>{{ currentEvaluation.snapshot ? formatDate(currentEvaluation.snapshot.updated_at) :
                  '' }}
                  </td>
                </tr>
                <tr v-if="displayScholar">
                  <th scope="row">{{ $t('scholarlevels.scholar.label') }}</th>
                  <td>{{ currentEvaluation.snapshot ? $t('scholarlevels.scholar.' + getScholarLabel(currentEvaluation.snapshot.scholar_level)) :
                  '' }}
                  </td>
                </tr>
                <tr v-if="displayProfessional">
                  <th scope="row">{{ $t('professionallevels.professional.label') }}</th>
                  <td>{{ currentEvaluation.snapshot ? $t('professionallevels.professional.' + getProfessionalLabel(currentEvaluation.snapshot.professional_level)) :
                  '' }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('satisfactionperceptions.satisfaction.label_short') }}</th>
                  <td>{{ currentEvaluation.snapshot ? $t('satisfactionperceptions.satisfaction.' + getPerceptionLabel(currentEvaluation.snapshot.satisfaction_perception)) :
                  '' }}
                  </td>
                </tr>
                <tr v-if="displayComments">
                  <th scope="row" class="align-top">{{ $t('evaluation.snapshot.comments') }}</th>
                  <td class="comments">{{ currentEvaluation.snapshot ? currentEvaluation.snapshot.comments
                  : '' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Snapshots menu -->
          <div v-if="isSnapshotsMenuVisible" class="btn-group">
            <button type="button" class="btn btn-outline-light dropdown-toggle" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              <fa icon="folder" fixed-width/>
              {{ currentSnapshot ? currentSnapshot.title : $t('evaluation.snapshots') }}
            </button>
            <div class="dropdown-menu">

              <a v-if="canSaveSnapshot" class="dropdown-item" href="#" @click="beforeSaveAs()">
              <font-awesome-icon icon="save"/> {{ $t('save_as') }}</a>
              <div v-if="hasSnapshot && canUpdateSnapshot"
                   :class="{disabledwrapper: currentSnapshot.isLocked}"
                   :title="askManager(currentSnapshot.isLocked)">
                <a v-if="hasSnapshot && canUpdateSnapshot"
                   :class="{disabled: currentSnapshot.isLocked}"
                   class="dropdown-item"
                   href="#"
                   @click="beforeSave()"><font-awesome-icon icon="save"/> {{ $t('save') }}</a>
              </div>
              <div v-if="hasSnapshot && canUpdateSnapshot"
                   :class="{disabledwrapper: currentSnapshot.isLocked}"
                   :title="askManager(currentSnapshot.isLocked)">
                <a v-if="hasSnapshot && canUpdateSnapshot"
                   :class="{disabled: currentSnapshot.isLocked}"
                   class="dropdown-item"
                   href="#"
                   @click="$refs.deleteSnapshotModal.show()"><font-awesome-icon icon="trash-alt"/> {{ $t('delete') }}</a>
              </div>
              <a v-if="isManager(user) && hasSnapshot"
                 :class="{disabled: !currentSnapshot.isLocked}"
                 class="dropdown-item"
                 href="#"
                 @click="unlockSnapshot()"><font-awesome-icon icon="unlock-alt"/> {{ $t('unlock') }}</a>

              <div v-if="hasSnapshot && currentTab == 1" class="dropdown-divider"/>
              <a v-if="hasSnapshot && currentTab == 1" class="dropdown-item" href="#"
                 @click="showAccompagnyingSheet()">{{ $t('manage.requirements_profiles.display_sheet')
                 }}</a>

              <div v-if="hasSnapshot" class="dropdown-divider"/>
              <a v-if="hasSnapshot" class="dropdown-item" href="#" @click="closeSnapshot()"><font-awesome-icon icon="times-circle"/> {{ $t('close')
              }}</a>

              <div v-if="currentSnapshots.length > 0" class="dropdown-divider"/>
              <a v-for="snapshot in currentSnapshots" :title="createToolTip(snapshot)"
                 class="dropdown-item" href="#" @click="requestSnapshot(snapshot)">{{ snapshot.title
                 }}</a>

              <div v-if="isRequirementsTab" class="dropdown-divider"/>
              <a v-if="isRequirementsTab" class="dropdown-item" href="#" @click="openSelector()">{{
              $t('manage.requirements_profiles.open_publics') }}</a>

            </div>
          </div>

          <!-- Masks menu -->
          <div v-if="isMasksMenuVisible" class="btn-group">
            <button type="button" class="btn btn-outline-light dropdown-toggle" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              <fa icon="ban" fixed-width/>
              {{ currentMaskTitle }}
            </button>
            <div class="dropdown-menu">

              <a v-if="canSaveSnapshot" class="dropdown-item" href="#" @click="newMask()">{{ $t('new')
              }}</a>
              <a v-if="currentMask && canSaveSnapshot" class="dropdown-item" href="#" @click="saveMaskAs()">{{ $t('save_as')
              }}</a>
              <a v-if="isAuthorOfMask && !isMaskApproved" class="dropdown-item" href="#"
                 @click="editMask()">{{ $t('edit') }}</a>
              <a v-if="isAuthorOfMask && !isMaskApproved" class="dropdown-item" href="#"
                 @click="$refs.deleteMaskModal.show()">{{ $t('delete') }}</a>

              <div v-if="currentMask" class="dropdown-divider"/>
              <a v-if="currentMask && canSaveSnapshot" class="dropdown-item" href="#" @click="closeMask()">{{ $t('close')
              }}</a>

              <div v-if="masks.length > 0" class="dropdown-divider"/>
              <template v-if="masks.length < 10">
                <a v-for="mask in masksOfType" class="dropdown-item" href="#" @click="applyMask(mask)">{{
                mask.title }}</a>
              </template>
              <template v-else>
                <a class="dropdown-item" href="#" @click="$refs.masksSelector.show()">{{
                $t('evaluation.mask.browse') }}</a>
              </template>
              <!--a v-if="masks.length == 0" class="dropdown-item muted">{{ $t('evaluation.mask.no_mask') }}</a-->

            </div>
          </div>
        </div>

        <!-- Tabs -->
        <ul id="pills-tab" class="nav nav-tabs card-header-tabs" role="tablist">
          <li v-for="(evaluation, key) in evaluations" class="nav-item">
            <span :aria-controls="evaluation.title"
                  :href="`#${evaluation.title}`"
                  :id="`${evaluation.title}-tab`"
                  :class="{ 'nav-link' : true, 'active' : currentTab == key }"
                  aria-selected="true"
                  data-toggle="pill"
                  role="tab"
                  @click="checkIfRightTab(key)">
              <fa :icon="evaluationsTypes[key].icon"/> {{ $t('evaluations.tabs.' + evaluationsTypes[key].title) }}{{ evaluation.snapshot ? ` (${evaluation.snapshot.title})` : '' }} {{ evaluation.updated ? ' *' : '' }}
            </span>
          </li>
          <li class="nav-item">
            <span id="reports-tab"
                  :class="{ 'nav-link': true, 'active': currentTab == 3 }"
                  aria-controls="reports"
                  aria-selected="true"
                  data-toggle="pill"
                  href="#reports"
                  role="tab"
                  @click="checkIfRightTab(3)">
              <fa icon="print"/> {{ $t('reports.reports') }}
            </span>
          </li>

        </ul>
      </div>

      <!-- Body -->
      <div id="pills-tabContent" class="card-body tab-content">
        <div v-for="(evaluation, key) in evaluations"
             :key="key"
             :class="{ 'active': currentTab == key }"
             :id="evaluation.title"
             :aria-labelledby="`${evaluation.title}-tab`"
             class="tab-pane fade show"
             role="tabpanel">
          <h4 v-if="currentSnapshot && currentSnapshot.isLocked" class="locked">{{ $t('evaluation.locked') }}</h4>
          <EvaluationX ref="evaluation"
                       :evaluation="evaluation"
                       @info="$refs.infoModal.show()"
                       @updated="onUpdate(evaluation, key)"/>

        </div>
        <div id="reports"
             :class="{ 'active': currentTab == 3 }"
             class="tab-pane"
             role="tabpanel"
             aria-labelledby="reports-tab">

          <Reports v-if="recipient"
                   ref="report"
                   :recipient="recipient"
                   :evaluations="evaluations"
                   :current-tab="currentTab"
                   :snapshots="snapshots"
                   :snapshot-kid="snapshotKid"
                   :snapshot-adult="snapshotAdult"
                   :snapshot-young="snapshotYoung"
                   :create-tool-tip="createToolTip"
          />
        </div>
      </div>
    </div>

    <!-- Modals -->
    <b-modal ref="warningSnapshotModal"
             :title="$t('error_alert_title')"
             ok-variant="warning"
             centered
             @cancel.prevent="closeWarningSnapshotModal()"
             @ok.prevent="okWarningSnapshotModal()">
      <p class="text-warning">{{ $t('evaluation.form_not_full') }}</p>
    </b-modal>

    <b-modal ref="deleteMaskModal"
             :title="$t('evaluation.mask.delete')"
             :ok-title="$t('delete')"
             :cancel-title="$t('cancel')"
             ok-variant="danger"
             centered
             @ok.prevent="deleteMask()">
      <form @submit.prevent="deleteMask()" @keydown="form.onKeydown($event)">
        <div class="form-group">
          {{ $t('evaluation.ask_remove', [ currentMaskTitle ]) }}
        </div>
      </form>
    </b-modal>

    <MaskModal ref="maskModalEval" :form-type="currentEvaluation.title" @saved="saveMask"/>

    <b-modal ref="deleteSnapshotModal"
             :title="$t('evaluation.snapshot.delete')"
             :ok-title="$t('delete')"
             :cancel-title="$t('cancel')"
             ok-variant="danger"
             centered
             @ok.prevent="deleteSnapshot()">
      <form @submit.prevent="deleteSnapshot()" @keydown="form.onKeydown($event)">
        <div class="form-group">
          {{ $t('evaluation.ask_remove', [ currentEvaluation.snapshot ? currentEvaluation.snapshot.title : ''
          ]) }}
        </div>
      </form>
    </b-modal>

    <SaveSnapshotModal
      ref="saveSnapshotModal"
      @saved="saveSnapshot"
    />

    <b-modal ref="wrongTabModal"
             centered
             ok-cancel
             @ok.prevent="setTab()"
             @cancel.prevent="dontSetTab()">
      <p>{{ $t('evaluation.wrong_tab') }}</p>
    </b-modal>

    <AccompanyingSheet v-if="isRequirementsTab" ref="accompanyingSheet" :read-only="!canUpdateSnapshot"
                       :snapshot="currentSnapshot" @saved="updateSnapSheet"/>
    <ProfilesSelector ref="selector" :profiles="requirementsProfiles" @openSnaphot="applySnapshot"/>
    <MasksSelector ref="masksSelector" :masks="masks" :current-evaluation="currentEvaluation"
                   @openMask="applyMask"/>

  </div>
</template>

<script>
import Form from 'vform'
import axios from 'axios'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { isProfessional, isRecipient, isManager, isStudent } from '~/plugins/auth'
import Evaluation from './Evaluation'
import EvaluationX from './EvaluationX'
import SaveSnapshotModal from './evaluation/SaveSnapshotModal'
import AWN from 'vue-awesome-notifications'

export default {
  name: 'Evaluations',
  components: { Evaluation, EvaluationX, SaveSnapshotModal, AWN },
  props: {
    recipient: { required: true, type: Object }
  },

  data: () => ({
    evaluations: [
      {
        id: 1,
        title: 'kid',
        color: '#0D2454',
        data: [],
        snapshot: null,
        updated: false
      }, {
        id: 2,
        title: 'young',
        color: '#7d2d17',
        data: [],
        snapshot: null,
        updated: false
      }, {
        id: 3,
        title: 'adult',
        color: '#074118',
        data: [],
        snapshot: null,
        updated: false
      }
    ],
    currentTab: 0,
    rightTab: 0,
    userAge: 0,
    currentMask: null,
    masks: [],
    snapshots: [],
    requirementsProfiles: [],
    form: new Form({
      id: 0,
      evaluation_id: 0,
      recipient_id: 0,
      mask_id: null,
      title: new Date().toJSON().slice(0, 10).split('-').reverse().join('/'),
      comments: '',
      contributors: []
    }),
    snapshotTitle: '',
    showSheetForm: false,
    savingNew: false,
    snapshotKid: '',
    snapshotAdult: '',
    snapshotYoung: '',
    toastSuccess: {
      group: 'foo',
      type: 'success'
    }
  }),

  computed: {

    canSaveSnapshot () {
      return this.user && ((!isRecipient(this.user) && !isStudent(this.user)) || (isRecipient(this.user) && this.currentTab >= 0 && this.currentTab <= 2))
    },

    canUpdateSnapshot () {

      if (this.isManager) {
        return true
      }

      if (!this.hasSnapshot) {
        return false
      }

      if (!this.isRequirementsTab) {
        return this.user && ((this.currentSnapshot.creator_id == this.user.id) || (!isRecipient(this.user) && !isManager(this.user)))
      } else {
        return this.user && (!isRecipient(this.user) && !isManager(this.user)) &&
                        (!this.currentSnapshot.accompanying_sheet ||
                            (this.currentSnapshot.accompanying_sheet && (this.currentSnapshot.creator_id == this.user.id || isManager(this.user)) && !this.currentSnapshot.accompanying_sheet.approved))
      }
    },

    currentEvaluation () {
      return this.evaluations[this.currentTab % this.evaluations.length]
    },

    currentMaskTitle () {
      return this.currentMask ? this.currentMask.title : this.$t('evaluation.masks')
    },

    currentSnapshot () {
      return this.currentEvaluation.snapshot
    },

    currentSnapshots () {
      const evaluationId = this.currentEvaluation.id
      let filtered = this.snapshots.filter(snapshot => snapshot.evaluation_id == evaluationId)

      if (this.isRequirementsTab) {
        filtered = filtered.filter(x => !x.accompanying_sheet || (x.accompanying_sheet && !x.accompanying_sheet.approved))
      }

      return filtered
    },

    hasSnapshot () {
      if (this.currentSnapshot) {
        return this.currentSnapshot.hasOwnProperty('id')
      }

      return false
    },

    isAuthorOfMask () {
      return this.user && this.currentMask && this.currentMask.creator_id == this.user.id
    },

    isMaskApproved () {
      return this.currentMask.approved
    },

    masksOfType: function () {
      return this.masks.filter(x => x.form_type == this.currentEvaluation.title)
    },

    isMasksMenuVisible () {
      return this.currentTab < 3 && !isRecipient(this.user)
    },

    isProfessional () {
      return isProfessional(this.user)
    },

    isRecipient () {
      return isRecipient(this.user)
    },

    isRequirementsTab () {
      return this.currentTab > 3
    },

    isSnapshotsMenuVisible () {
      return this.currentTab < 3
    },

    isReportTab () {
      return this.currentTab == 3
    },

    potentialContributors () {
      var pros = this.recipient.recipient.professionals // Yes, 'recipient.recipient' is correct.
      return pros.filter(p => p.id != this.user.id, this)
    },

    recipientFullName () {
      return this.recipient.nick_name
    },

    snapshotCreator () {
      return this.getSnapshotCreator()
    },

    ...mapGetters({
      evaluationsTypes: 'evaluations/evaluations',
      user: 'auth/user'
    })
  },

  mounted () {
    // Initialize evaluations.
    this.evaluationsTypes.forEach((type, index) => {
      this.evaluations[index].id = type.id
      this.evaluations[index].title = type.title
      this.evaluations[index].icon = type.icon
      this.evaluations[index].data = this.$store.getters['evaluations/' + type.title].entries
    })
    this.setRightTab()

    this.loadMasks()
    this.loadSnapshots()
    this.setRecipientMask()
  },

  methods: {

    setRightTab () {
      this.userAge = new Date().getFullYear() - this.recipient.birth_year
      if (this.userAge >= 0 && this.userAge <= 4) {
        this.rightTab = 0
      } else if (this.userAge > 4 && this.userAge <= 13) {
        this.rightTab = 1
      } else {
        this.rightTab = 2
      }
      this.checkIfRightTab(this.rightTab)
    },

    /**
             * Recursive subroutine to apply mask
             *
             * @param mask List of nodes to show and ignore.
             */
    $_applyMask (mask, index, data) {
      index.value++

      for (let i = 0; i < data.length; i++) {
        let node = data[i]
        let masked = mask.mask[index.value] === '0'

        // node.masked = masked

        Vue.set(node, 'masked', masked)

        if (masked) {
          index.value++
          continue
        } else {
          this.$_applyMask(mask, index, node.children)
        }
      }
    },

    /**
     * Apply given mask to tree views.
     *
     * @param mask List of nodes to show and ignore.
     */
    setRecipientMask () {
      if (isRecipient(this.user)) {
        if (this.snapshots) {
          this.getSingleMask(this.snapshots[this.snapshots.length - 1])
        }
      }
    },

    getLastUsedMaskId () {
      this.snapshots.sort((a, b) => a.updated_at.localeCompare(b.updated_at))
      return this.snapshots[this.snapshots.length - 1].mask_id
    },

    applyMask (mask) {
      const data = this.evaluations[this.currentTab].data // evaluations[0] means abilities
      const index = { value: 0 } // Iterator.

      // Recursive application.
      this.$_applyMask(mask, index, data[0].children)

      this.updateEvaluation()

      this.currentMask = mask
    },

    getMask (id) {
      let mask = this.masks.filter(m => m.id == id)
      if (mask) {
        return mask[0]
      }
      return null
    },

    /**
             * Subroutine for applySnapshot.
             *
             * @param data Snapshot list.
             * @param index Index in the snapshot list.
             * @param node Node in data tree.
             * @param defaultValue Value to ignore (don't save default value).
             */
    $_applySnapshot (data, index, node) {
      if (node.children.length == 0) {
        this.$refs.evaluation[this.currentTab].setSnapshot(data)
        index[0] += 1
      } else {
        for (let i = 0; i < node.children.length; i++) {
          this.$_applySnapshot(data, index, node.children[i])
        }
      }
    },

    /**
             * Apply snapshot to tree views.
             *
             * @param snapshot List of values to assign.
             */
    requestSnapshot (snapshot) {
      this.getSingleMask(snapshot)
    },

    applySnapshot (snapshot) {
      if (this.currentMask) {
        this.applyMask(this.currentMask)
      } else {
        this.closeMask()
      }

      let data = JSON.parse(snapshot.snapshot)
      let evaluation = this.currentEvaluation.data
      let index = [0] // Value in array so it can be passed by reference.

      this.$_applySnapshot(data, index, evaluation[0])

      // Vue.set(this.currentEvaluation, 'snapshot', snapshot);
      this.currentEvaluation.snapshot = snapshot
      this.currentEvaluation.updated = false

      this.updateCurrentEvaluation()
    },

    closeMask () {
      this.currentMask = null
      this.resetMask(this.currentEvaluation.data[0])
      this.updateCurrentEvaluation()
    },

    closeSnapshot () {
      this.closeMask()
      this.resetEvaluation()
      this.currentEvaluation.updated = false
      this.currentEvaluation.snapshot = null

      this.resetSnapshot(this.currentEvaluation.data[0])
      this.updateCurrentEvaluation()
    },

    createToolTip (snapshot) {
      let lines = [this.$t('evaluation.snapshot.author') + ': ' + this.getSnapshotCreator(),
        this.$t('creation') + ': ' + this.formatDate(snapshot.created_at),
        this.$t('evaluation.snapshot.last_updated') + ': ' + this.formatDate(snapshot.updated_at),
        this.$t('evaluation.snapshot.comments') + ': ' + (snapshot.comments == null ? '' : snapshot.comments)
      ]

      return lines.join('\n')
    },

    askManager (locked) {
      if (locked) {
        return this.$t('evaluation.ask_manager')
      }
    },

    async deleteMask () {
      await axios.delete('/api/evaluations/masks/' + this.currentMask.id)
        .then((response) => {
          // Remove snapshot from list.
          let index = this.masks.indexOf(this.currentMask)
          this.masks.splice(index, 1)

          // Reset data.
          this.setToastTxt(this.$t('toast.success'), this.currentMask.title + ' ' + this.$t('toast.delete'))
          this.closeMask()

          // Hide modal.
          this.$refs.deleteMaskModal.hide()
        })
        .catch((error) => {
          console.error(error)
        })
    },

    async deleteSnapshot () {
      await axios.delete('/api/users/' + this.recipient.id + '/evaluations/snapshots/' + this.currentEvaluation.snapshot.id)
        .then((response) => {
          // Remove snapshot from list.
          let index = this.snapshots.indexOf(this.currentEvaluation.snapshot)
          this.snapshots.splice(index, 1)

          // Reset data.
          this.setToastTxt(this.$t('toast.success'), this.currentSnapshot.title + ' ' + this.$t('toast.delete'))
          this.closeSnapshot()
          // Hide modal.
          this.$refs.deleteSnapshotModal.hide()
        })
        .catch((error) => {
          console.error(error)
        })
    },

    editMask () {
      if (this.currentMask) {
        this.$refs.maskModalEval.editMask(this.currentMask)
      }
    },

    formatDate (date) {
      if (date) {
        return Date.fromDateTime(date).toUserLocaleString(this)
      }

      return ''
    },

    getSnapshotCreator () {
      if (this.currentSnapshot && this.currentSnapshot.hasOwnProperty('created_by')) {
        const author = this.currentEvaluation.snapshot.created_by
        let name = author.first_name + ' ' + author.last_name
        return name
      }

      return ''
    },

    async loadMasks () {
      await axios.get('/api/evaluations/masks')
        .then((response) => {
          this.masks = response.data
        })
        .catch((error) => {
          console.error(error)
          this.form = error.data
        })
    },

    async getSingleMask (snapshot) {
      await axios.get('/api/evaluations/masks/' + snapshot.mask_id)
        .then((response) => {
          this.currentMask = response.data
          this.applySnapshot(snapshot)
        })
        .catch((error) => {
          this.applySnapshot(snapshot)
        })
    },

    async loadRequirementsProfiles () {
      await axios.get('/api/evaluations/requirements')
        .then((response) => {
          this.requirementsProfiles = response.data
        })
        .catch((error) => {
          console.error(error)
          this.form = error.data
        })
    },

    async loadSnapshots () {
      await axios.get('/api/users/' + this.recipient.id + '/evaluations/snapshots')
        .then((response) => {
          this.snapshots = response.data
          this.setRecipientMask()
        })
        .catch((error) => {
          console.error(error)
          this.form = error.data
        })
    },

    newMask () {
      this.$refs.maskModalEval.new()
    },

    onUpdate (evaluation, key) {
      evaluation.updated = true
    },

    openSelector () {
      this.$refs.selector.show()
    },

    resetMask (data) {
      Vue.delete(data, 'masked')

      for (let i = 0; i < data.children.length; i++) {
        this.resetMask(data.children[i])
      }
    },

    resetSnapshot (data) {
      if (data.children.length > 0) {
        for (let i = 0; i < data.children.length; i++) {
          this.resetSnapshot(data.children[i])
        }
      } else {
        Vue.delete(data, 'value')
        Vue.set(data, 'comment', '')
      }
    },

    resetForm () {
      this.form.id = 0
      this.form.mask_id = null
      this.form.recipient_id = 0
      this.form.title = ''
      this.form.comments = ''
      this.form.contributors = []
    },

    resetTrees () {
      for (let i = 0; i < this.evaluations.length; i++) {
        this.evaluations[i].snapshot = null
        this.resetSnapshot(this.evaluations[i].data[0])
        this.$refs['evaluation'][i].update()
      }
    },

    save () {
      this.savingNew = false

      const snapshot = this.currentEvaluation.snapshot
      this.form.id = snapshot.id
      this.form.recipient_id = snapshot.recipient_id
      this.form.title = snapshot.title
      if (this.currentMask) {
        this.form.mask_id = this.currentMask.mask_id
      } else {
        this.form.mask_id = null
      }
      this.form.comments = snapshot.comments
      this.form.isLocked = this.$refs.evaluation[this.currentTab].validate()
      if (this.hasSnapshot && this.canUpdateSnapshot) {
        this.saveSnapshot()
      }
    },

    saveAs () {
      this.resetForm()
      this.$refs.saveSnapshotModal.show()
    },

    saveMask (mask) {
      if (!this.$refs.maskModalEval.edit) {
        this.masks.push(mask)
        this.currentMask = mask
      } else {
        var index = this.masks.indexOf(this.masks.filter(x => x.id === mask.id)[0])
        Vue.set(this.masks, index, mask)
      }
      this.setToastTxt(this.$t('toast.success'), this.currentMask.title + ' ' + this.$t('toast.save'))
      this.applyMask(mask)
    },

    saveMaskAs () {
      if (this.currentMask) {
        this.$refs.maskModalEval.editMask(this.currentMask, false)
      }
    },

    async saveSnapshot (value) {
      let evaluationId = this.evaluationsTypes[this.currentTab].id

      // Populate form.
      let snapshot = this.$refs.evaluation[this.currentTab].getSnapshot()

      this.form.evaluation_id = evaluationId
      this.form.recipient_id = this.recipient.id
      this.form.snapshot = JSON.stringify(snapshot)
      if (this.currentMask) {
        this.form.mask_id = this.currentMask.id
      }
      if (value !== undefined) {
        this.form.title = value.title
        this.form.scholar_level = value.scholar
        this.form.professional_level = value.professional
        this.form.satisfaction_perception = value.satisfaction
        this.form.filling_context = value.filling_context
        this.form.comments = value.comments
      }
      // Send form.
      try {
        const isNew = this.form.id === 0
        const url = `/api/users/${this.recipient.id}/evaluations/snapshots`

        if (isNew) {
          const response = await this.form.post(url)
          const data = response.data

          // Push new snapshot into datas.
          this.snapshots.push(data)
          this.currentEvaluation.snapshot = data
          this.applySnapshot(data)
          this.currentSnapshot.isLocked = data.isLocked
        } else {
          const response = await this.form.patch(url)
          const data = response.data
          const index = this.snapshots.map(x => x.id).indexOf(data.id)
          this.currentSnapshot.isLocked = data.isLocked
          Vue.set(this.snapshots, index, data)
        }

        this.currentSnapshot.title = this.form.title
        this.currentEvaluation.updated = false

        // Hide and reset modal.
        this.$refs.saveSnapshotModal.hide()
        if (isNew) { this.setToastTxt(this.$t('toast.success'), this.currentSnapshot.title + ' ' + this.$t('toast.create')) } else {
          if (!this.form.isLocked) { this.setToastTxt(this.$t('toast.success'), this.currentSnapshot.title + ' ' + this.$t('toast.unlock')) } else { this.setToastTxt(this.$t('toast.success'), this.currentSnapshot.title + ' ' + this.$t('toast.save')) }
        }
        // Show accompagnying sheet if necessary.
        if (this.isRequirementsTab && (this.showSheetForm || this.savingNew)) {
          this.showAccompagnyingSheet()
        }
      } catch (error) {
        console.error(error)
      }
    },

    async unlockSnapshot () {
      this.savingNew = false

      var snapshot = this.currentEvaluation.snapshot
      this.form.id = snapshot.id
      this.form.recipient_id = snapshot.recipient_id
      this.form.title = snapshot.title
      if (this.currentMask) {
        this.form.mask_id = this.currentMask.mask_id
      } else {
        this.form.mask_id = null
      }
      this.form.comments = snapshot.comments
      this.form.isLocked = false
      this.form.unlockedBy = this.user.id
      if (this.hasSnapshot && this.canUpdateSnapshot) {
        this.saveSnapshot()
      }
    },

    checkIfRightTab (index) {
      this.currentTab = index
      if (index !== this.rightTab && index >= 0 && index <= 2) {
        this.$refs.wrongTabModal.show()
      } else if (index === 3) {
        this.getSnapshotKid()
        this.getSnapshotYoung()
        this.getSnapshotAdult()
      }
    },

    setTab () {
      this.$refs.wrongTabModal.hide()
      this.resetTab()
    },

    resetTab () {
      this.closeMask()
      this.closeSnapshot()
      this.loadMasks()
    },

    dontSetTab () {
      this.$refs.wrongTabModal.hide()
      this.currentTab = this.rightTab
    },

    showAccompagnyingSheet () {
      this.$refs.accompanyingSheet.show()
    },

    updateEvaluation () {
      this.$refs.evaluation[this.currentTab].update()
    },

    resetEvaluation () {
      this.$refs.evaluation[this.currentTab].reset()
    },

    updateCurrentEvaluation () {
      this.$refs['evaluation'][this.currentTab].update()
      if (this.currentSnapshot) {
        this.showSheetForm = this.isRequirementsTab && this.currentSnapshot.accompanying_sheet == null
      }
    },

    updateSnapSheet ({ sheet, authors }) {
      if (this.currentSnapshot) {
        this.currentSnapshot.accompanying_sheet = sheet

        this.updateContributors(authors)
      }
    },

    beforeSaveAs () {
      this.savingNew = true

      if (!this.$refs.evaluation[this.currentTab].validate()) {
        this.$refs.warningSnapshotModal.show()
      } else {
        this.saveAs()
      }
    },

    beforeSave () {
      this.savingNew = false

      if (!this.$refs.evaluation[this.currentTab].validate()) {
        this.$refs.warningSnapshotModal.show()
      } else {
        this.save()
      }
    },

    closeWarningSnapshotModal () {
      this.$refs.warningSnapshotModal.hide()
    },

    okWarningSnapshotModal () {
      this.closeWarningSnapshotModal()

      if (this.savingNew) {
        this.saveAs()
      } else {
        this.save()
      }
    },

    getSnapshotKid () {
      this.snapshotKid = this.getSnapshotByEvalId(1)
    },
    getSnapshotYoung () {
      this.snapshotYoung = this.getSnapshotByEvalId(2)
    },
    getSnapshotAdult () {
      this.snapshotAdult = this.getSnapshotByEvalId(3)
    },

    getSnapshotByEvalId (id) {
      return this.snapshots.filter(snapshot => snapshot.evaluation_id === id)
    },

    displayComments () {
      if (this.currentEvaluation.snapshot !== null) {
        if (this.currentEvaluation.snapshot.comments !== null || this.currentEvaluation.snapshot.comments !== '') {
          return true
        }
      }
      return false
    },

    getScholarLabel (i) {
      return this.$refs.saveSnapshotModal.scholarLevels[i].label
    },

    displayScholar () {
      if (this.currentEvaluation.snapshot !== null) {
        if (this.currentEvaluation.snapshot.scholar_level !== null || this.currentEvaluation.snapshot.scholar_level !== undefined) {
          return true
        }
      }
      return false
    },

    getProfessionalLabel (i) {
      return this.$refs.saveSnapshotModal.professionalLevels[i].label
    },

    displayProfessional () {
      if (this.currentEvaluation.snapshot !== null) {
        if (this.currentEvaluation.snapshot.professional_level !== null) {
          return true
        }
      }
      return false
    },

    getPerceptionLabel (i) {
      return this.$refs.saveSnapshotModal.satisfactionPerceptions[i].label
    },

    isManager () {
      return isManager(this.user)
    },

    isStudent () {
      return isStudent(this.user)
    },

    setToastTxt (title, text) {
      let options = this.toastSuccess
      options.title = title
      options.text = text
      this.$notify(options)
    }
  }
}
</script>

<style scoped>

    .disabledwrapper {
      cursor: not-allowed;
    }

    .disabled {
      pointer-events: none;
      opacity: 0.6;
      color: lightgrey;
    }

    .card-header div:first-child {
        margin: 0.5rem 0 1rem 0;
    }

    .card-header .card-header-tabs {
        margin-left: 0rem;
    }

    .card-header-tabs .nav-link .svg-inline--fa {
        font-size: unset;
    }

    .card-header .btn-outline-primary:not(#title) {
        border: 1px solid transparent;
    }

    .card-header .btn-outline-secondary:hover {
        border: 1px solid $ secondary;
    }

    .snapshot-infos {
        padding: 1em;
    }

    .snapshot-infos th,
    .snapshot-infos td {
        padding: 0 0.5em;
    }

    .snapshot-infos th {
        text-align: right;
    }

    span.nav-link {
        cursor: pointer;
        user-select: none;
    }

    .comments {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: inherit;
    }

    #acc-sheet-modal {
        overflow-y: auto;
    }

    .card-header {
        color: white;
    }

    label {
      padding:4px 24px 0px 24px;
      font-weight:bold;
    }

    .locked {
      background-color: #ffc4c4;
      color: darkred;
      text-align: center;
      width: 100%;
      padding: 10px;
      border: 1px solid darkred;
      border-radius: 10px;
    }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Evaluations.vue